import { render, staticRenderFns } from "./NewslettersCreate.vue?vue&type=template&id=626f88f6&"
import script from "./NewslettersCreate.vue?vue&type=script&lang=js&"
export * from "./NewslettersCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports